// types
import type { InternalLink } from '@ts-sections/section-internal-link/interfaces'
// hooks
import { useEventsSection } from '@hooks/events/sections/events-section.hook'

interface BlockInternalLinkHookReturn {
  buildChipHref: (item: InternalLink) => string
  handleChipClick: (item: InternalLink) => void
}

export const useBlockInternalLink = (): BlockInternalLinkHookReturn => {
  const { buildCtaHref, trackSectionEvent } = useEventsSection({ sectionName: 'internal-link' })

  const buildChipHref = (item: InternalLink): string => buildCtaHref(item.link, { text: item.text })

  const handleChipClick = (item: InternalLink): void => {
    trackSectionEvent('Link_click', { name: 'internal_link', text: item.text, url: item.link })
  }

  return {
    buildChipHref,
    handleChipClick,
  }
}
